import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

const availablePlansSlice = createSlice({
  name: "availablePlans",
  initialState: {
    availablePlans: [],
    isAvailablePlansLoading: false,
    isAvailablePlansError: false,
  },
  reducers: {
    setAvailablePlans: (
      state,
      action: PayloadAction<{ availablePlans: AvailablePlan[] }>,
    ) => {
      state.availablePlans = action.payload.availablePlans;
    },
    setAvailablePlansLoadingStatus: (state, action) => {
      const { loading, error } = action.payload;
      state.isAvailablePlansLoading = loading;
      state.isAvailablePlansError = error;
    },
    setAvailablePlanDescriptions: (
      state,
      action: PayloadAction<{
        planDescriptions: { planId: string; description: string }[];
      }>,
    ) => {
      const { planDescriptions } = action.payload;
      state.availablePlans = state.availablePlans.map((ap) => {
        return {
          ...ap,
          description:
            planDescriptions.find((pd) => pd.planId === ap.id)?.description ||
            "",
        };
      });
    },
  },
});

export const {
  setAvailablePlans,
  setAvailablePlansLoadingStatus,
  setAvailablePlanDescriptions,
} = availablePlansSlice.actions;
export const availablePlansSliceReducer = availablePlansSlice.reducer;
